import { xor as _xor } from 'lodash';
import { Commit } from 'vuex';

import { IPreferencesState } from './preferencesIndex';

export const createRemoveFromListMutator = (property: string) => (state: IPreferencesState, payload: any) => {
    const { userId, value } = payload;
    const index = (state[userId] as any)[property].indexOf(value);

    if (index === -1) {
        return;
    }
    (state[userId] as any)[property].splice(index, 1);
};

export const createToggleListElementMutator = (property: string) =>
    (state: IPreferencesState, payload: any) => {
        const { userId, value } = payload;
        (state[userId] as any)[property] = _xor((state[userId] as any)[property], [value]);
    };

export const createSimpleMutatorAction = (mutation: string) =>
    ({ commit, getters }: { commit: Commit; getters: any }, value: any) => {
        commit(mutation, { value, userId: getters._userId });
    };
